var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yCode"},[_c('span',{on:{"click":_vm.send}},[_vm._v("发送验证码")])])
}
var staticRenderFns = []

export { render, staticRenderFns }